"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const StyledEngineProvider_1 = __importDefault(require("@material-ui/styled-engine/StyledEngineProvider"));
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const react_modal_promise_1 = __importDefault(require("react-modal-promise"));
const identity_1 = require("@dfinity/identity");
const App_1 = __importDefault(require("./App"));
const store_1 = __importDefault(require("../store"));
const CanisterClientFactory_1 = __importDefault(require("../services/CanisterClientFactory"));
const Login_1 = __importDefault(require("./Login"));
const ThemeProvider_1 = __importDefault(require("./ThemeProvider"));
const usersReducer_1 = require("../reducers/usersReducer");
const RegisterUser_1 = __importDefault(require("./RegisterUser"));
const getCurrentUser_1 = __importDefault(require("../actions/users/getCurrentUser"));
const authClient_1 = __importDefault(require("../utils/authClient"));
const notifySessionExpired_1 = require("../actions/signin/notifySessionExpired");
const SessionExpirationHandler_1 = __importDefault(require("../domain/SessionExpirationHandler"));
const switchViewMode_1 = __importDefault(require("../actions/app/switchViewMode"));
const viewMode_1 = require("../domain/model/viewMode");
const gotoChat_1 = require("../actions/chats/gotoChat");
const gotoHome_1 = __importDefault(require("../actions/app/gotoHome"));
const Alert_1 = require("./modals/Alert");
exports.default = AppRoot;
const useStyles = makeStyles_1.default((theme) => ({
    "@global": {
        body: {
            backgroundColor: theme.colors.outerBackgroundColor,
            lineHeight: 1.5
        },
        header: {
            backgroundColor: theme.colors.header.backgroundColor,
            height: 52,
            flexShrink: 0,
            padding: "0 15px"
        },
        input: {
            backgroundColor: "transparent"
        },
        a: {
            color: theme.colors.linkColor
        },
        "body, input": {
            color: theme.colors.textColor
        },
        "h1": {
            fontSize: "6rem",
            fontWeight: 300,
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: "3rem"
            }
        }
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    container: {
        padding: 24,
        height: "100%",
        "&.no-padding": {
            padding: 0
        },
        [theme.breakpoints.down('sm')]: {
            position: "fixed",
            top: 0
        }
    }
}));
function AppRoot() {
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_1.default },
        react_1.default.createElement(StyledEngineProvider_1.default, { injectFirst: true },
            react_1.default.createElement(ThemeProvider_1.default, null,
                react_1.default.createElement(AppContainer, null)))));
}
function AppContainer() {
    const dispatch = react_redux_1.useDispatch();
    const identity = authClient_1.default().getIdentity();
    const isAnonymous = identity.getPrincipal().isAnonymous();
    const [canisterClientFactoryRequiresInit, setCanisterClientFactoryRequiresInit] = react_1.useState(!isAnonymous && CanisterClientFactory_1.default.current == null);
    const sessionExpired = react_redux_1.useSelector((state) => state.appState.sessionExpired);
    const currentUser = react_redux_1.useSelector((state) => state.usersState.me);
    const userRegistrationStatus = react_redux_1.useSelector((state) => state.usersState.userRegistrationStatus);
    const currentViewMode = react_redux_1.useSelector((state) => state.appState.viewMode);
    const modalSpinner = react_redux_1.useSelector((state) => state.appState.modalSpinner);
    const classes = useStyles();
    const theme = useTheme_1.default();
    const targetViewMode = useMediaQuery_1.default(theme.breakpoints.down("sm")) ? viewMode_1.ViewMode.Mobile : viewMode_1.ViewMode.Desktop;
    const removePadding = useMediaQuery_1.default(theme.breakpoints.down("lg"));
    let containerClass = classes.container;
    let component;
    let large = false;
    if (canisterClientFactoryRequiresInit) {
        component = react_1.default.createElement("div", null);
    }
    else if (isAnonymous || (sessionExpired && userRegistrationStatus !== usersReducer_1.UserRegistrationStatus.Registered)) {
        component = react_1.default.createElement(Login_1.default, null);
    }
    else {
        switch (userRegistrationStatus) {
            case usersReducer_1.UserRegistrationStatus.Unknown:
                dispatch(getCurrentUser_1.default());
                component = null;
                break;
            case usersReducer_1.UserRegistrationStatus.NotRegistered:
                component = react_1.default.createElement(RegisterUser_1.default, null);
                break;
            case usersReducer_1.UserRegistrationStatus.Registered:
                large = true;
                component = react_1.default.createElement(App_1.default, null);
                break;
        }
    }
    if (removePadding && large) {
        containerClass += " no-padding";
    }
    react_1.useEffect(() => {
        if (sessionExpired) {
            (() => __awaiter(this, void 0, void 0, function* () {
                yield Alert_1.alertDialog({
                    title: "Session Expired",
                    text: "Your session has expired - please login again",
                });
                dispatch(notifySessionExpired_1.sessionExpiryAcknowledged());
            }))();
        }
    }, [sessionExpired]);
    react_1.useEffect(() => {
        if (currentViewMode !== targetViewMode) {
            dispatch(switchViewMode_1.default(targetViewMode));
        }
    }, [targetViewMode, currentViewMode]);
    react_1.useEffect(() => {
        if (canisterClientFactoryRequiresInit) {
            CanisterClientFactory_1.default.init(identity).then(_ => setCanisterClientFactoryRequiresInit(false));
        }
    }, []);
    react_1.useEffect(() => {
        window.onpopstate = function (event) {
            var _a;
            if ((_a = event.state) === null || _a === void 0 ? void 0 : _a.chatId) {
                dispatch(gotoChat_1.gotoChatById(event.state.chatId, undefined, true));
            }
            else {
                dispatch(gotoHome_1.default());
            }
        };
        return () => {
            window.onpopstate = () => null;
        };
    }, []);
    react_1.useEffect(() => {
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        function setDocVh() {
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
        window.onresize = () => setDocVh();
        setDocVh();
    }, []);
    react_1.useEffect(() => {
        if (currentUser && !isAnonymous && identity instanceof identity_1.DelegationIdentity) {
            SessionExpirationHandler_1.default.startSession();
        }
    }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container_1.default, { maxWidth: large ? "lg" : "md", className: containerClass },
            component,
            react_1.default.createElement(react_modal_promise_1.default, null)),
        react_1.default.createElement(Backdrop_1.default, { className: classes.backdrop, open: modalSpinner },
            react_1.default.createElement(CircularProgress_1.default, { color: "inherit" }))));
}
